<template>
  <div class="modal-contacts-wrapper">
    <div class="title"> {{ title }}</div>
    <div class="subtitle"> {{ subtitle }}</div>
    <div class="d-md-flex">
      <div class="w-100 mb-4 mb-lg-0 me-lg-1">
        <MainInput :label="placeholderName" v-model="form.name" :theme="'solid-grey'" :type="'text'"/>
      </div>
      <div class="ms-lg-1 w-100">
        <MainInput :label="placeholderContact" v-model="form.contact" :theme="'solid-grey'" :type="'text'"/>
      </div>
    </div>
    <div class="text-area mt-4 mb-5">
      <TextArea :label="placeholderMessage" v-model="form.message"/>
    </div>
    <div class="col-md-6">
      <MainButton :button-text="buttonText" @click="send" :size="'medium'" :theme="'solid-blue'"/>
    </div>
  </div>
</template>

<script>
import MainInput from "@/components/Common/Inputs/MainInput.vue";
import TextArea from "@/components/Common/Inputs/TextArea.vue";
import MainButton from "@/components/Common/Buttons/MainButton.vue";

export default {
  name: 'ModalContacts',
  components: {MainButton, MainInput, TextArea},
  props: {
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    placeholderName: {
      type: String,
    },
    placeholderContact: {
      type: String,
    },
    placeholderMessage: {
      type: String,
    },
    buttonText: {
      type: String,
    },
  },
  data() {
    return {
      form: {
        name: null,
        contact: null,
        message: null
      }
    }
  },
  methods: {
    async send() {
      this.$emit('onFormSubmit', this.form);
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-contacts-wrapper {
  font-family: $font-regular;
  color: $color-brown;

  .title {
    font-size: $subtitle-1;

  }

  .subtitle {
    font-size: $paragraph-2;
    margin-bottom: $spacing-5;
  }
}

@media screen and (min-width: 768px) {
  .modal-contacts-wrapper {
    .title {
      font-size: $title-h5;
    }

    .subtitle {
      font-size: $paragraph-1;
    }
  }
}
</style>